<template>
  <div class="sb-navigation">
    <div class="position-relative py-3">
      <div
        v-for="(industry_key, industry_idx) in Object.keys(sasb_contents)"
        :key="`navigation-group-${industry_idx}-${industry_key}`"
        class="navigation-group"
      >
        <div v-if="Object.keys(sasb_contents[industry_key]['sustainability_metrics']).length > 0">
          <div :class="['d-flex align-items-center mb-3 pl-3', { 'mt-4': industry_idx !== 0 }]">
            <h5
              class="nav-title nav-title--parent"
              :data-observe-anchor="'rp' + industry_key"
              :class="{
                'navigation-indicator': industry_idx === 0
              }"
            >
              <b-link
                class="nav-anchor text-keep-all text-decoration-none"
                @click="scroll_to_title('rp' + industry_key)"
              >
                <span v-show="lang === 'KOR'">{{
                  sasb_contents[industry_key]['industry_name']
                }}</span>
                <span v-show="lang === 'ENG'">{{
                  sasb_contents[industry_key]['industry_name_e']
                }}</span>
              </b-link>
            </h5>
          </div>

          <h6
            v-for="(topic_key, topic_idx) in Object.keys(
              sasb_contents[industry_key]['sustainability_metrics']
            )"
            :key="topic_idx"
            :class="['nav-title nav-title--child', 'mb-0', 'ml-3']"
            :data-observe-anchor="'trp' + industry_key + topic_idx"
          >
            <b-link
              class="nav-anchor text-keep-all text-decoration-none"
              @click="scroll_to_title('trp' + industry_key + topic_idx)"
            >
              <span v-show="lang === 'KOR'">{{
                sasb_contents[industry_key]['sustainability_metrics'][topic_key]['topic_name']
              }}</span>
              <span v-show="lang === 'ENG'">{{
                sasb_contents[industry_key]['sustainability_metrics'][topic_key]['topic_name_e']
              }}</span>
            </b-link>
          </h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'SASBTocViewer',
  computed: {
    ...mapState('report_list', ['lang']),
    ...mapState('report_contents', ['sasb_contents']),
    ...mapGetters('report_list', ['selected_report']),
    anchorList() {
      return Object.keys(this.sasb_contents).reduce((_anchors, industryKey) => {
        const industry = this.sasb_contents[industryKey];

        if (industry) {
          _anchors.push(`#rp${industryKey}`);
        }
        if (industry && Object.keys(industry['sustainability_metrics'])) {
          Object.keys(industry['sustainability_metrics']).forEach((topicKey, topic_idx) => {
            _anchors.push(`#trp${industryKey}${topic_idx}`);
          });
        }
        return _anchors;
      }, []);
    }
  },
  mounted() {
    setTimeout(() => {
      this.anchorObserver = new IntersectionObserver(this.handlerObserveAnchor, {
        rootMargin: '0% 0% -78.5% 0%',
        threshold: 1
      });
      this.anchorList.forEach(_anchor => {
        const _anchorTitle = document.querySelector(_anchor);
        if (_anchorTitle) {
          this.anchorObserver.observe(_anchorTitle);
        }
      });
      const initialNav = document.querySelector('.navigation-indicator');
      if (initialNav) {
        initialNav.style.color = this.selected_report.main_color;
        initialNav.style.borderLeft = `4px solid ${this.selected_report.main_color}`;
      }
    }, 400);
  },
  data() {
    return {
      anchorObserver: null
    };
  },
  methods: {
    handlerObserveAnchor(entries) {
      if (entries.length) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const _navToAnchor = document.querySelectorAll(
              `[data-observe-anchor="${entry.target.id.replace(/#/g, '')}"]`
            );
            if (_navToAnchor.length) {
              const _activedNavs = document.querySelectorAll('.navigation-indicator');
              if (_activedNavs.length) {
                _activedNavs.forEach(_activedNav => {
                  _activedNav.classList.remove('navigation-indicator');
                  _activedNav.style.color = '';
                  _activedNav.style.borderLeft = '';
                });
              }
              this.activatedAnchor = entry.target.id.replace(/#/g, '');
              _navToAnchor[0].childNodes[0].classList.add('navigation-indicator');
              _navToAnchor[0].childNodes[0].style.color = this.selected_report.main_color;
              _navToAnchor[0].childNodes[0].style.borderLeft = `4px solid ${this.selected_report.main_color}`;
            }
          }
        });
      }
    },
    scroll_to_title(link) {
      const element = document.getElementById(link);
      if (element) {
        element.style.scrollMarginTop = '100px';
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<style></style>
